import React from "react";

// icons
import { FcSalesPerformance } from "react-icons/fc"
import {SiPowerautomate} from 'react-icons/si'
import { FcCustomerSupport } from 'react-icons/fc'

//
import { Link } from "react-router-dom";
import { ChevronRight } from "@mui/icons-material";


function Speciality() {

    return (
        <section className="speciality" id="speciality">
            <div className="speciality-header-wrapper">
                <div className="speciality-header container mb-3">
                    <h3 className="speciality-subtitle section-subtitle">Why Choose Us?</h3>
                    <div className="speciality-highlight flex">
                        <div>

                            <h2 className="h2 section-title">
                                Still not sure why to choose us? Here is why we are different with others.
                            </h2>
                        </div>

                        <p className="speciality-text">
                            Whether you're starting out or scalling up, grow faster with <strong>DEEPBLUE</strong>. Take a look at some of the best benefits that you will get.
                        </p>
                    </div>
                </div>
            </div>
            <div className="content-wrapper container">
                {/* First service */}
                <div className="mt-4">
                    <div className="speciality-content">
                        <ul className="speciality-list">
                            <li className="speciality-item">
                                <div className="speciality-item-icon">
                                    <FcSalesPerformance />
                                </div>
                                <h2 className="section-subtitle">Increase Sales</h2>
                            </li>
                        </ul>

                        <p className="speciality-text">
                            Automate your sales, marketing, and service in one platform. Avoid data leakes and enable consistent messaging.
                        </p>
                        <ul className="speciality-list column">
                            <li className="speciality-item">
                                <div className="speciality-item-icon">
                                    <ChevronRight />
                                </div>
                                <p className="speciality-item-text">Close more deals with single-page contact management</p>
                            </li>
                            <li className="speciality-item">
                                <div className="speciality-item-icon">
                                    <ChevronRight />
                                </div>
                                <p className="speciality-item-text">Enjoy one-click calling, call scripts and voicemail automation</p>
                            </li>
                            <li className="speciality-item">
                                <div className="speciality-item-icon">
                                    <ChevronRight />
                                </div>
                                <p className="speciality-item-text">Track stages and milestones of your deals to keep that sales process on track</p>
                            </li>

                        </ul>
                    </div>

                </div>
                {/* second service */}
                <div className="mt-4">
                    <div className="speciality-content">
                        <ul className="speciality-list">
                            <li className="speciality-item">
                                <div className="speciality-item-icon">
                                    <SiPowerautomate />
                                </div>
                                <h2 className="section-subtitle">Marketing Automation</h2>
                            </li>
                        </ul>
                        <p className="speciality-text">
                            Market like the most successful companies in the world with Agile CRMS's marketing automation software.
                        </p>
                        <ul className="speciality-list column">
                            <li className="speciality-item">
                                <div className="speciality-item-icon">
                                    <ChevronRight />
                                </div>
                                <p className="speciality-item-text">Marketing workflows with an easy drag-and-drop designer</p>
                            </li>
                            <li className="speciality-item">
                                <div className="speciality-item-icon">
                                    <ChevronRight />
                                </div>
                                <p className="speciality-item-text">Integrate social media easily into your marketing campaigns and contact views.</p>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Third Service */}
                <div className="mt-4">
                    <div className="speciality-content">
                        <ul className="speciality-list">
                            <li className="speciality-item">
                                <div className="speciality-item-icon">
                                    <FcCustomerSupport />
                                </div>
                                <h2 className="section-subtitle"> Help Desk Software</h2>
                            </li>
                        </ul>

                        <p className="speciality-text">
                            Great customer support seperates decent companies from excellent companies. A positive customer support experience is a crucially important piece of the customer journey.
                        </p>
                        <ul className="speciality-list column">
                            <li className="speciality-item">
                                <div className="speciality-item-icon">
                                    <ChevronRight />
                                </div>
                                <p className="speciality-item-text">Enjoy at-a-glance views of important data - such as ticket priority - on your dashboard.</p>
                            </li>
                            <li className="speciality-item">
                                <div className="speciality-item-icon">
                                    <ChevronRight />
                                </div>
                                <p className="speciality-item-text">Categorize tickets according to the issue and route them to the appropriate group. (e.g sales or support)</p>
                            </li>
                            <li className="speciality-item">
                                <div className="speciality-item-icon">
                                    <ChevronRight />
                                </div>
                                <p className="speciality-item-text">Resolve every issue in the shortest possible time with powerful ticketing features.</p>
                            </li>

                        </ul>
                        <p className="callout">
                            "All my complaints get resolved instantly when I text or call the sales department.
                            They are always around to give out their hands and get our
                            feedbacks if the problems have been resolved." - <strong>Andy Murphy, Tech Lead - SA Tech</strong>"
                        </p>

                        <Link to="/auth" className="btn">
                            Try for free
                        </Link>
                    </div>
                </div>
            </div>
            {/* End */}
        </section>
    );
}

export default Speciality;
